function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["breadcrumbTitle", "children", "visibleItemsOnMobile", "className", "renderResponsive", "breakpoint"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, Fragment } from 'react';
import { string, node, number, bool, oneOf } from 'prop-types';
import classNames from 'classnames';
import uuid from 'uuid';
import './Breadcrumbs.scss';
var propTypes = {
  /** Title for the breadcrumbs. Visible on small screens */
  breadcrumbTitle: node.isRequired,

  /** Use `<BreadcrumbsItem/>` as children */
  children: node,

  /** Add your own custom class names to the component */
  className: string,

  /** Renders the last item and a back button instead of the whole list on small devices (defined by the breakpoint prop). */
  renderResponsive: bool,

  /** Add the breakpoint where you want the responsive behaviour to kick in. The default is the same as a SMALL breakpoint in the RDS CSS. */
  breakpoint: number,

  /** Choose how many items you want visible on mobile devices. */
  visibleItemsOnMobile: number
};
var defaultProps = {
  breadcrumbTitle: 'You Are Here',
  breakpoint: 768,
  renderResponsive: true,
  visibleItemsOnMobile: 2
};
/**
 * A page-trail to indicate to the users where they are and able them to navigate to previous pages.
 * @description Experimental!
 */

var Breadcrumbs = /*#__PURE__*/function (_Component) {
  _inherits(Breadcrumbs, _Component);

  var _super = _createSuper(Breadcrumbs);

  function Breadcrumbs(props) {
    var _this;

    _classCallCheck(this, Breadcrumbs);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "widthChange", function (mq) {
      if (mq.matches) {
        this.setState({
          view: 'mobile'
        });
      } else {
        this.setState({
          view: 'desktop'
        });
      }
    });

    _this.breadcrumbTitleId = "rds-breadcrumbs__title-".concat(uuid.v4());
    _this.breadcrumbsId = "rds-breadcrumbs-".concat(uuid.v4());
    _this.widthChange = _this.widthChange.bind(_assertThisInitialized(_this));
    _this.mq = window.matchMedia("(max-width: ".concat(props.breakpoint, "px)"));
    _this.state = {
      view: undefined
    };
    return _this;
  } // media query change


  _createClass(Breadcrumbs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mq.addListener(this.widthChange);
      this.widthChange(this.mq);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mq.removeListener(this.widthChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          breadcrumbTitle = _this$props.breadcrumbTitle,
          children = _this$props.children,
          visibleItemsOnMobile = _this$props.visibleItemsOnMobile,
          className = _this$props.className,
          renderResponsive = _this$props.renderResponsive,
          breakpoint = _this$props.breakpoint,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var desktopClassNames = classNames('rds-breadcrumbs', className);
      var mobileClassNames = classNames('rds-breadcrumbs rds-breadcrumbs--mobile', className);
      var visibleItems = visibleItemsOnMobile;
      /* Create the list for DESKTOP based on children */

      var desktopChildren = React.Children.map(children, function (child, index) {
        /* Only one child */
        if (!children.length) {
          child = /*#__PURE__*/React.cloneElement(child, {
            hasIcon: false
          });
          return child;
        }

        if (index === children.length - 1) {
          child = /*#__PURE__*/React.cloneElement(child, {
            hasIcon: false
          });
        } else {
          child = /*#__PURE__*/React.cloneElement(child, {
            hasIcon: true
          });
        }

        return child;
      });
      /* Create the list for MOBILE based on children */

      var mobileChildren = React.Children.map(children, function (child, index) {
        /* Visible items on mobile should always be at least one */
        if (visibleItemsOnMobile <= 1) {
          visibleItems = 1;
        }
        /* Only one child */


        if (!children.length) {
          child = /*#__PURE__*/React.cloneElement(child, {
            hasIcon: false
          });
          return child;
        }
        /* The last item in the list */


        if (index === children.length - 1) {
          child = /*#__PURE__*/React.cloneElement(child, {
            hasIcon: false
          });
        } else if (index >= children.length - visibleItems) {
          /* Remaining items based on visibleItemsOnMobile */
          child = /*#__PURE__*/React.cloneElement(child, {
            hasIcon: true
          });
          /* Replace the first invisible child with a back-link */
        } else if (_this2.state.view === 'mobile' && children.length > visibleItems) {
          /* The last invisible item when mobile view */
          if (index === children.length - 1 - visibleItems) {
            child = /*#__PURE__*/React.cloneElement(child, {
              hasIcon: false,
              renderResponsive: true
            });
          } else {
            child = null;
          }
        } else {
          /* Don't show more than visibleItemsOnMobile */
          child = null;
        }

        return child;
      });
      var desktopBreadcrumbs = /*#__PURE__*/React.createElement("nav", _extends({
        className: desktopClassNames,
        id: this.breadcrumbsId
      }, breadcrumbTitle && {
        'aria-labelledby': this.breadcrumbTitleId
      }, rest), breadcrumbTitle && /*#__PURE__*/React.createElement("span", {
        className: 'rds-breadcrumbs__title',
        id: this.breadcrumbTitleId
      }, breadcrumbTitle), /*#__PURE__*/React.createElement("ol", {
        className: 'rds-breadcrumbs__list'
      }, desktopChildren));
      var mobileBreadcrumbs = /*#__PURE__*/React.createElement("nav", _extends({
        className: mobileClassNames,
        id: this.breadcrumbsId
      }, breadcrumbTitle && {
        'aria-labelledby': this.breadcrumbTitleId
      }, rest), breadcrumbTitle && /*#__PURE__*/React.createElement("span", {
        className: 'rds-breadcrumbs__title',
        id: this.breadcrumbTitleId
      }, breadcrumbTitle), /*#__PURE__*/React.createElement("ol", {
        className: 'rds-breadcrumbs__list'
      }, mobileChildren));
      return /*#__PURE__*/React.createElement(Fragment, null, renderResponsive ? this.state.view === 'mobile' ? mobileBreadcrumbs : desktopBreadcrumbs : desktopBreadcrumbs);
    }
  }]);

  return Breadcrumbs;
}(Component);

Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;
export default Breadcrumbs;